import isMobileAppRuntime from 'utils/isMobileAppRuntime';

export const usesTouchActivityLayout = () => isMobileAppRuntime()
  || (typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    && window.matchMedia('(hover: none) and (pointer: coarse)').matches);
